module.exports = __webpack_public_path__ + "img/sanko-logo.7a2ce848.png";